import { EventEmitter, Injectable } from '@angular/core';
import { TreeViewOrigin } from 'app/modules/common/enums/common-enums';
import { CompanyTreeNode } from '../entities/selected-company.model';

@Injectable({
  providedIn: 'root'
})
export class CompanyTreeViewService {

  private _origin = TreeViewOrigin.Header;
  private _selectedCompany: any;

  public companySelected = new EventEmitter<CompanyTreeNode>();
  
  constructor() {}

  set origin(origin: TreeViewOrigin) {
    this._origin = origin;
  }

  get origin(): TreeViewOrigin {
    return this._origin;
  }

  set selectedCompany(selectedCompany: any) {
    this._selectedCompany = selectedCompany;
  }

  get selectedCompanyId(): number {
    if (this._selectedCompany !== undefined && this._selectedCompany !== null) {
      return Number(this._selectedCompany.id);
    }

    return 0;
  }

  get selectedCompanyName(): string {
    if (this._selectedCompany !== undefined && this._selectedCompany !== null) {
      return this._selectedCompany.text;
    }

    return undefined;
  }

  public setSelectedCompany(node: CompanyTreeNode) {
    this.companySelected.emit(node);
  }

}
